import React from "react";

const StatusBadge = ({ status }) => {
  const colors = {
    pending: {
      backgroundColor: '#fef3c7',
      color: '#92400e',
      borderColor: '#fbbf24'
    },
    in_process: {
      backgroundColor: '#dbeafe',
      color: '#1e40af',
      borderColor: '#60a5fa'
    },
    approved: {
      backgroundColor: '#d1fae5',
      color: '#065f46',
      borderColor: '#6ee7b7'
    },
    rejected: {
      backgroundColor: '#fee2e2',
      color: '#b91c1c',
      borderColor: '#f87171'
    }
  };

  const labels = {
    pending: "Pending",
    in_process: "In Process", 
    approved: "Approved",
    rejected: "Rejected"
  };

  const statusStyle = colors[status] || colors.pending;
  const statusLabel = labels[status] || status;

  const style = {
    padding: '4px 12px',
    borderRadius: '9999px',
    fontSize: '12px',
    fontWeight: '600',
    border: '1px solid',
    display: 'inline-block',
    ...statusStyle
  };

  return (
    <span style={style}>
      {statusLabel}
    </span>
  );
};

export default StatusBadge;